module.exports = "/assets/landing-dw/instagram/insta-feed-4.jpg?mPpFHKb";